import "../../../../src/content/grandeprairie-streaming/grandeprairie.scss";
import * as React from 'react';
export default {
  React
};